import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, Subject, Subscription} from 'rxjs';
import {shareReplay, takeUntil} from 'rxjs/operators';
import {Question} from '../../models/underwriter.model';
import {FlowPlayerService} from '../../services/flow-player.service';
import {GlobalQuestionService} from '../../services/global-question.service';
import {MiniQuestionQuery} from '../state/mini-question.query';
import {MiniQuestionStore} from '../state/mini-question.store';
import {QuestionFlowSessionQuery} from '../state/question-flow-session.query';
import {MiniQuestionFlowSessionQuery} from '../state/mini-question-flow-session.query';
import { Alert } from 'src/app/modules/shared/utilities';
import { QuestionFlowSessionStore } from '../state/question-flow-session.store';

declare var $: any;

@Component({
    selector: 'app-question-mini-flow-controller',
    templateUrl: './question-mini-flow-controller.component.html',
    styleUrls: ['./question-mini-flow-controller.component.scss'],
    standalone: false
})
export class QuestionMiniFlowControllerComponent implements OnInit, OnDestroy {

  @Input() question: Question;
  @Input() max_item_id: string;
  @Input() item_id = '0';
  @Input() edit = false;
  @Output() questionAnswer = new EventEmitter();
  @Output() disableButtonChange = new EventEmitter<boolean>();

  activeQuestion: Question;
  childrenQuestions: Question[] = [];
  disabledButton = true;
  progress = '0%';
  session_details: any;
  showFlowController = false;
  private questionQuerySubscription: Subscription;

  constructor(
    public questionService: GlobalQuestionService,
    private flowPlayer: FlowPlayerService,
    private sessionDetailsQuery: QuestionFlowSessionQuery,
    private miniQuestionsQuery: MiniQuestionQuery,
    private questionFlowSessionStore: QuestionFlowSessionStore,
    private miniFlowSessionQuery: MiniQuestionFlowSessionQuery,
    private miniQuestionStore: MiniQuestionStore) {
  }

  ngOnInit(): void {
    this.progress = '10%';
    if (this.question?.session_id){
      this.questionFlowSessionStore.update({
        item_id: this.question?.item_id,
        class_id:  this.question?.class_id,
        category_id:  this.question?.category_id,
        group_id:  this.question?.product_group_id,
        session_id:  this.question?.session_id,
        flow_id:  this.question?.flow_id,
        dependant_flow_id:  this.question?.dependant_flow_id,
      });
    }
    console.log(this.item_id, this.edit)
    if (+this.item_id > 0 && this.edit) {
      this.showFlowController = true;
      $('#question-container').slideDown(300);
      this.startFlow((this.item_id).toString());
    }
    if (+this.max_item_id === 0) {
      this.loadMiniFlow();
    }
  }

  loadMiniFlow(): void {
    /*$('#question-add-container').animate({height: 'toggle', opacity: 'toggle'}, 200, (e: any) => {
      console.log('Animation....');
      // then slide in q
      $('#question-container').slideDown(300);
      this.startFlow((+this.max_item_id + 1).toString());
    });*/
    this.showFlowController = true;
    $('#question-container').slideDown(300);
    this.startFlow((+this.max_item_id + 1).toString());
    this.progress = (this.questionService.calculateProgress(this.childrenQuestions) * 100).toString()+'%';
  }

  addItem(): void {
    this.disableButtonChange.emit(true);
    this.loadMiniFlow();
  }

  removeItem(): void {
    this.removeMiniflow();
  }


  getPrevious(): void {
    this.questionService.getPrevious(this.session_details.session_id, this.activeQuestion.flow_id, this.activeQuestion.item_id, this.activeQuestion.cent_aq_question_id)
      .subscribe((response: any[]) => {
        if (response?.length) {
          if (response[0].next > 0){
            this.miniQuestionStore.setActive(response[0].next);
          }
          else{
            Alert('<strong>' + (response[0]?.alert ? response[0]?.alert  : 'Sorry, going back from this screen is not allowed at this point but you will be able to edit all answers later in the process.' ) + '</strong>');
            
          }
          
        }
      });
  }

  startFlow(item_id: string): void {
    this.childrenQuestions = [];
    this.session_details = this.sessionDetailsQuery.getValue();
    this.item_id = item_id;
    console.log('Starting mini flow for item id:', this.session_details, this.question);
    this.flowPlayer.startMiniFlow(this.session_details?.flow_id, this.question?.dependant_flow_id, this.session_details?.class_id, this.session_details?.category_id, this.session_details?.group_id, item_id, this.session_details?.session_id)
      .add(() => {
        const childQuestions = this.miniQuestionsQuery.getAll();
        if (childQuestions?.length) {
          for (const question of childQuestions) {
            const questionCopy = Object.assign({}, question);
            if (!this.childrenQuestions?.some(g => g?.cent_aq_question_id === questionCopy?.cent_aq_question_id)) {
              this.childrenQuestions.push(questionCopy);
              this.saveChildQuestionWithoutAnswer(questionCopy);
            }
          }
        }
        this.getCurrentQuestion();
        this.activateNext(this.activeQuestion);
      });
  }

  activateNext(event): void {
    const questionIndex = this.childrenQuestions?.findIndex((question: Question) => question.cent_aq_question_id === event.cent_aq_question_id);
    if (questionIndex > -1) {
      this.childrenQuestions[questionIndex] = event;
    }
    this.enableButton();
  }

  enableButton(): void {
    this.disabledButton = !this.activeQuestion.answer;
  }

  saveChildQuestionWithoutAnswer(question: Question): void {
    if (question) {
      question.answer = '';
      this.questionService.saveIndividualAnswer(question, this.item_id);
    }
  }

  submitResponse(): void {
    this.disabledButton = true;
    this.activeQuestion.item_id = this.item_id;
    this.saveResponseMiniFlow(this.activeQuestion);
  }

  removeMiniflow(): void {
    this.questionService.setSelectedMiniFlowItem(this.activeQuestion?.product_class_id, this.item_id);
    // slide q away
    $('#question-container').slideUp(200, () => {
      // set btn to 0 opacity
      $('#question-add-container')
        .css('opacity', 0)
        // slide btn in
        .animate({height: 'toggle'}, 200,
          () => {
            // then fade btn in
            $('#question-add-container').animate({opacity: '1'}, 200);
          }
        );
    });
  }

  getCurrentQuestion(): void {
    this.questionQuerySubscription = (this.miniQuestionsQuery.selectActive() as Observable<Question>)
      .subscribe({
        next: question => {
          if (question) {
            this.activeQuestion = Object.assign({}, question);
            this.enableButton();
          } else {
            this.emitChanges();
          }
        }
      });
  }

  saveResponseMiniFlow(question: Question): void {
    const session_details = this.miniFlowSessionQuery.getValue();
    const answer_id = question.answer_id ? question.answer_id : 0;
    const item_id = question?.item_id ? question?.item_id : '0';
    const class_id = (question?.product_class_id ? question?.product_class_id : 0) === 0 ? (session_details?.class_id ? session_details?.class_id : 0) : question?.product_class_id;
    this.questionService.saveAnswer(session_details?.session_id, question?.cent_aq_question_id, class_id, item_id, question?.answer, answer_id, question?.comment, session_details?.flow_id)
      .subscribe(() => {
        if (question?.call_proc) {
          this.questionService.runCommand(
            this.questionService.replaceCallProcParemeters(
              question?.call_proc,
              item_id,
              session_details?.session_id,
              (question?.product_class_id ? question?.product_class_id : 0),
              question?.page,
              session_details?.flow_id,
              question?.cent_aq_question_id,
              session_details?.group_id,
              question?.category_id
            )).subscribe((val: any[]) => {
              
              if (val?.length && val[0]?.next) {
                
                this.questionService.saveFlowHistory(session_details?.session_id, question?.flow_id, question?.item_id, question?.cent_aq_question_id, val[0]?.next, question?.product_class_id).subscribe();
                this.getFlowQuestions(question?.flow_id, session_details?.category_id, session_details?.session_id, session_details?.group_id, item_id, val[0]?.next);
              } else {
                this.getMiniFlowNext(
                  question,
                  session_details?.session_id,
                  item_id,
                  session_details?.flow_id,
                  session_details?.category_id,
                  question?.index,
                  session_details?.superflow_id,
                  session_details?.group_id
                );
              }
            });
        } else {
          this.questionService.saveFlowHistory(session_details?.session_id, question?.flow_id, question?.item_id, question?.cent_aq_question_id, question?.next, question?.product_class_id).subscribe();
          this.getMiniFlowNext(
            question,
            session_details?.session_id,
            item_id,
            session_details?.flow_id,
            session_details?.category_id,
            question?.index,
            session_details?.superflow_id,
            session_details?.group_id
          );
        }
      });
  }

  getMiniFlowNext(question: Question, session_id: any, item_id: any, flowId: any, categoryId: any, index: any, superflow_id: any, group_id: any): any {
    if (!question?.conditions?.length || !question?.next) {
      if (!question?.next) {
        this.questionService.setShoppingCart(question, item_id);
        this.miniQuestionStore.setActive(null);
      } else {
        this.getFlowQuestions(flowId, categoryId, session_id, group_id, item_id, question?.next);
      }
    } else {
      return this.questionService.getNextQuestion(question, session_id, item_id, flowId, index)
        .subscribe((val: any[]) => {
          if (val?.length && val[0]?.next) {
            this.getFlowQuestions(flowId, categoryId, session_id, group_id, item_id, val[0]?.next);
          }
        });
    }
    this.progress = (this.questionService.calculateProgress(this.childrenQuestions) * 100).toString()+'%';
  }

  getFlowQuestions(flow_id: number, category_id: number, session_id: any, group_id: number, item_id: string, next: number): void {
    this.flowPlayer.flowQuestions(flow_id, category_id, session_id, group_id, item_id)
      .subscribe((flowQuestions: Question[]) => {
        if (flowQuestions?.length) {
          const nextQuestion = flowQuestions?.find(f => f?.cent_aq_question_id === next);
          if (nextQuestion) {
            this.questionService.setShoppingCart(nextQuestion, item_id);
            flowQuestions = this.questionService.cleanQuestions(flowQuestions);
            this.miniQuestionStore.set(flowQuestions);
            this.miniQuestionStore.setActive(nextQuestion?.cent_aq_question_id);
            this.questionService.spinner(false);
          } else {
            this.miniQuestionStore.setActive(null);
          }
        }
      });
  }

  emitChanges(): void {
    const progress = this.questionService.calculateProgress(this.childrenQuestions) * 100;
    this.progress = `${progress}%`;
    if (!this.activeQuestion?.next) {
      this.question.answer = 'mini-flow';
      this.item_id = '0';
      this.max_item_id = '0';
      this.progress = '0%';
      this.questionAnswer.emit(this.question);
    }
  }

  ngOnDestroy(): void {
    this.questionQuerySubscription?.unsubscribe();
    /*this.unsubscribe$.next();
    this.unsubscribe$.complete();*/
  }

}
